import React, { ReactNode } from 'react';
import { Modal, Space } from 'antd';
import MainButton from 'components/MainButton/MainButton';

const ModalNoti: React.FC<{
  open: boolean;
  onClose: () => void;
  handleOk: () => void;
  title: string;
  subTitle: string | ReactNode;
}> = ({ open, onClose, handleOk, title, subTitle }) => (
  <Modal
    title={title}
    centered
    open={open}
    onCancel={onClose}
    footer={[
      <Space align="center" key="actions">
        <MainButton
          text="はい"
          onClick={() => {
            handleOk();
            onClose();
          }}
        />
      </Space>,
    ]}
  >
    <p>{subTitle}</p>
  </Modal>
);

export default ModalNoti;
